export const depositPaymentSwitching = {
  depositPaymentSwitching: 'Deposit Transaction',
  username: 'Username',
  paymentName: 'PaymentName',
  refCode1: 'Ref Code 1',
  status: 'Status',
  transactionId: 'Transaction ID',
  refCode3: 'Ref Code 3',
  createdAt: 'Created At',
  advanceFilter: 'Advance Filter',
  searchUsername: 'ค้นหาด้วย username',
  requestedAmount: 'Requested Amount',
  amount: 'Amount',
  message: 'Message',
  searchBankAccountNumber: 'ค้นหาด้วย bank account number',
}
